import { useEffect, useState } from "react";

export function is24h() {
  return localStorage.getItem("timely_clock_12h") !== "1";
}

export function toggleClock() {
  localStorage.setItem("timely_clock_12h", is24h() ? "1" : "0");
  window.dispatchEvent(new Event("timely-clock"));
}

export function fmtTime(hhmm, h24) {
  if (h24 || !hhmm || !/^\d{2}:\d{2}$/.test(hhmm)) return hhmm;
  let [h, m] = hhmm.split(":").map(Number);
  const suffix = h >= 12 ? "pm" : "am";
  h = h % 12 || 12;
  return `${h}:${String(m).padStart(2, "0")}${suffix}`;
}

export function useClock() {
  const [h24, setH24] = useState(is24h());
  useEffect(() => {
    const on = () => setH24(is24h());
    window.addEventListener("timely-clock", on);
    return () => window.removeEventListener("timely-clock", on);
  }, []);
  return h24;
}

export function ClockToggle({ className = "" }) {
  const h24 = useClock();
  return (
    <button type="button" onClick={toggleClock} data-testid="clock-toggle" title="Switch between 24-hour and 12-hour clock"
      className={className}>
      {h24 ? "24h" : "12h"}
    </button>
  );
}
